import React from 'react';
import { format } from 'date-fns';

const RequestListPageHeader = ({ 
  title, 
  description, 
  lastUpdated, 
  children,
  className = ""
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6 ${className}`}>
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-gray-900">{title}</h1>
          {description && (
            <p className="text-sm md:text-base text-gray-600">
              {description}
            </p>
          )}
          {lastUpdated && (
            <p className="text-xs text-gray-500 mt-1">
              Last updated: {format(lastUpdated, 'MMM dd, yyyy HH:mm:ss')}
            </p>
          )}
        </div>
        {children && (
          <div className="flex items-center space-x-4">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestListPageHeader;
